webpackJsonp([35783957827783],{

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(45);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(58);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(57);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(122);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(121);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	if (typeof window !== "undefined" && window.IntersectionObserver) {
	  io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      listeners.forEach(function (l) {
	        if (l[0] === entry.target) {
	          // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	          if (entry.isIntersecting || entry.intersectionRatio > 0) {
	            io.unobserve(l[0]);
	            l[1]();
	          }
	        }
	      });
	    });
	  }, { rootMargin: "200px" });
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  io.observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["opacity", "onLoad", "transitionDelay"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }
	  }));
	};
	
	Img.propTypes = {
	  opacity: _propTypes2.default.number,
	  transitionDelay: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        zIndex: 1,
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.35s"
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: ""
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func
	};
	
	exports.default = Image;

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: auto;\n  width: 100%;\n  background-color: ', ';\n'], ['\n  margin: auto;\n  width: 100%;\n  background-color: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  z-index: 3;\n\n  max-width: 1200px;\n  padding: 0 3rem;\n  width: 100%;\n  margin: auto;\n\n  display: grid;\n  grid-template-columns:  1fr repeat(2, 193.5px) 14vh repeat(2, 193.5px) 1fr;\n  grid-template-rows: repeat(60, 110.5px);\n  grid-gap: 0.5rem;\n  z-index: 1;\n'], ['\n  z-index: 3;\n\n  max-width: 1200px;\n  padding: 0 3rem;\n  width: 100%;\n  margin: auto;\n\n  display: grid;\n  grid-template-columns:  1fr repeat(2, 193.5px) 14vh repeat(2, 193.5px) 1fr;\n  grid-template-rows: repeat(60, 110.5px);\n  grid-gap: 0.5rem;\n  z-index: 1;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  grid-row: ', ' ', ';\n  grid-column: ', ' ', ';\n  background-color: ', ';\n  border: ', ';\n\n  z-index: ', ';\n  box-shadow: ', ';\n'], ['\n  grid-row: ', ' ', ';\n  grid-column: ', ' ', ';\n  background-color: ', ';\n  border: ', ';\n\n  z-index: ', ';\n  box-shadow: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  justify-content: ', ';\n\n  color: ', ';\n  margin: 20px;\n\n  p {\n    font-size: ', ';\n    line-height: 1.2;\n    margin: 0;\n  }\n\n  h1 {\n    color: ', ';\n    margin: 0;\n  }\n\n  a {\n    font-size: ', ';\n    color: ', ';\n    text-decoration: underline;\n\n    &:hover {\n      opacity: 0.75;\n      text-decoration: none;\n    }\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: ', ';\n\n  color: ', ';\n  margin: 20px;\n\n  p {\n    font-size: ', ';\n    line-height: 1.2;\n    margin: 0;\n  }\n\n  h1 {\n    color: ', ';\n    margin: 0;\n  }\n\n  a {\n    font-size: ', ';\n    color: ', ';\n    text-decoration: underline;\n\n    &:hover {\n      opacity: 0.75;\n      text-decoration: none;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  background-color: rgba(255,255,255,0.8);\n  padding: 64px 6px;\n  border-radius: 33px;\n\n  box-shadow: inset 0 2px 5px 1px rgba(255,255,255,0.6),\n    inset 0 -4px 12px 0 rgba(170, 180, 204, 0.49),\n    0px 10px 40px rgba(0,0,0,0.2);\n'], ['\n  background-color: rgba(255,255,255,0.8);\n  padding: 64px 6px;\n  border-radius: 33px;\n\n  box-shadow: inset 0 2px 5px 1px rgba(255,255,255,0.6),\n    inset 0 -4px 12px 0 rgba(170, 180, 204, 0.49),\n    0px 10px 40px rgba(0,0,0,0.2);\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  width: 378px;\n  border-radius: 4px;\n  box-shadow: 0px 0px 0px 1px rgba(255,255,255, 0.2);\n'], ['\n  width: 378px;\n  border-radius: 4px;\n  box-shadow: 0px 0px 0px 1px rgba(255,255,255, 0.2);\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  font-weight: normal;\n  color: white;\n\n  a {\n    color: white;\n    text-decoration: underline;\n\n    &:hover {\n      opacity: 0.75;\n      text-decoration: none;\n    }\n  }\n'], ['\n  font-size: ', ';\n  font-weight: normal;\n  color: white;\n\n  a {\n    color: white;\n    text-decoration: underline;\n\n    &:hover {\n      opacity: 0.75;\n      text-decoration: none;\n    }\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-between;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n\n  padding: 0.5rem 3rem;\n  font-size: ', ';\n'], ['\n  display: flex;\n  justify-content: space-between;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n\n  padding: 0.5rem 3rem;\n  font-size: ', ';\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  z-index: 0;\n  width: 100%;\n  height: 100vh;\n'], ['\n  position: fixed;\n  z-index: 0;\n  width: 100%;\n  height: 100vh;\n']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(27);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(299);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _screenRec = __webpack_require__(41);
	
	var _screenRec2 = _interopRequireDefault(_screenRec);
	
	var _screenRec3 = __webpack_require__(42);
	
	var _screenRec4 = _interopRequireDefault(_screenRec3);
	
	var _screenRec5 = __webpack_require__(43);
	
	var _screenRec6 = _interopRequireDefault(_screenRec5);
	
	var _screenRec7 = __webpack_require__(44);
	
	var _screenRec8 = _interopRequireDefault(_screenRec7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var baseFont = "2.4rem";
	var green = "#00DAAA";
	
	var Container = _styledComponents2.default.div(_templateObject, green);
	var GridContainer = _styledComponents2.default.div(_templateObject2);
	
	var GridBlock = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.row;
	}, function (props) {
	  return props.height ? '/' + (parseInt(props.height) + parseInt(props.row)) : " ";
	}, function (props) {
	  return props.col;
	}, function (props) {
	  return props.width ? '/' + (parseInt(props.col) + parseInt(props.width)) : " ";
	}, function (props) {
	  return props.bg ? props.bg : 'transparent';
	}, function (props) {
	  return props.border ? '2px solid ' + props.border : 'none';
	}, function (props) {
	  return props.above ? "2" : "0";
	}, function (props) {
	  return props.above ? "0px 10px 40px rgba(0,0,0,0.1);" : "none";
	});
	
	var BodyText = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.center ? "center" : "auto";
	}, function (props) {
	  return props.color ? props.color : "white";
	}, baseFont, function (props) {
	  return props.color ? props.color : "white";
	}, baseFont, function (props) {
	  return props.color ? props.color : "white";
	});
	
	var VideoContainer = _styledComponents2.default.div(_templateObject5);
	
	var Video = _styledComponents2.default.video(_templateObject6);
	
	var Image = (0, _styledComponents2.default)(_gatsbyImage2.default)(_templateObject6);
	
	var Title = _styledComponents2.default.h1(_templateObject7, baseFont);
	
	var Header = _styledComponents2.default.div(_templateObject8, baseFont);
	
	var Background = _styledComponents2.default.div(_templateObject9);
	
	var numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	
	var V2Page = function (_React$Component) {
	  _inherits(V2Page, _React$Component);
	
	  function V2Page(props) {
	    _classCallCheck(this, V2Page);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    console.log(props.data);
	
	    _this.state = {
	      scroll: 0
	    };
	
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  V2Page.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('scroll', this.handleScroll);
	  };
	
	  V2Page.prototype.handleScroll = function handleScroll(e) {
	    var scrollTop = window.scrollY;
	
	    if (scrollTop < 750) {
	      this.setState({
	        scroll: scrollTop
	      });
	    }
	  };
	
	  V2Page.prototype.render = function render() {
	    var _this2 = this;
	
	    var bgStyle = {
	      transform: 'translateY(' + this.state.scroll + 'px)'
	    };
	
	    return _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        Header,
	        null,
	        _react2.default.createElement(
	          Title,
	          null,
	          'Daze'
	        ),
	        _react2.default.createElement(
	          Title,
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#' },
	            'Download Now'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        Background,
	        { style: bgStyle },
	        numbers.map(function (c) {
	          var cNorm = c;
	          c = numbers.length - c;
	
	          var size = 14;
	          var boxStyle = {
	            width: c * size + "vh",
	            height: c * size + "vh",
	            position: "absolute",
	            borderRadius: "50%",
	            left: 'calc(50% - ' + c * size / 2 + 'vh)',
	            top: 50 - c * size / 2 + "vh",
	            transform: 'translateY(' + _this2.state.scroll * -1 * c + 'px)'
	          };
	
	          var cStyle = {
	            zIndex: 2,
	            top: "0",
	            position: "absolute",
	            backgroundColor: "white",
	            opacity: 0.75 - Math.pow(c, 2) / 100,
	            borderRadius: "50%",
	            width: "100%",
	            height: "100%"
	          };
	
	          var bStyle = _extends({}, cStyle);
	          bStyle.opacity = 1;
	          bStyle.zIndex = 1;
	          bStyle.backgroundColor = green;
	          //bStyle.border = "1px solid white"
	
	          if (c == 1 && _this2.state.scroll < 1000) {
	            cStyle.opacity = 1 - _this2.state.scroll / 2000;
	          } else if (c == 1) {
	            cStyle.opacity = 0.5;
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { key: c, style: boxStyle },
	            _react2.default.createElement('div', { style: cStyle }),
	            _react2.default.createElement('div', { style: bStyle })
	          );
	        })
	      ),
	      _react2.default.createElement(
	        GridContainer,
	        null,
	        _react2.default.createElement(
	          GridBlock,
	          { row: '12', col: '2', height: '2', width: '2', border: 'white' },
	          _react2.default.createElement(
	            BodyText,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Daily introspection for a better everyday.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          GridBlock,
	          { row: '11', col: '5', height: '3', width: '2', above: true },
	          _react2.default.createElement(
	            VideoContainer,
	            null,
	            _react2.default.createElement(Image, { resolutions: this.props.data.allFile.edges[1].node.childImageSharp.resolutions })
	          )
	        ),
	        _react2.default.createElement(
	          GridBlock,
	          { row: '15', col: '2', height: '3', width: '2', above: true },
	          _react2.default.createElement(
	            VideoContainer,
	            null,
	            _react2.default.createElement(Image, { resolutions: this.props.data.allFile.edges[2].node.childImageSharp.resolutions })
	          )
	        ),
	        _react2.default.createElement(
	          GridBlock,
	          { row: '19', col: '5', height: '3', width: '2', above: true },
	          _react2.default.createElement(
	            VideoContainer,
	            null,
	            _react2.default.createElement(Image, { resolutions: this.props.data.allFile.edges[3].node.childImageSharp.resolutions })
	          )
	        ),
	        _react2.default.createElement(
	          GridBlock,
	          { row: '30', col: '5', height: '3', width: '2', border: 'white' },
	          _react2.default.createElement(
	            BodyText,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Let Daze remember each day so you can focus on the present.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          GridBlock,
	          { row: '28', col: '2', height: '3', width: '2', above: true },
	          _react2.default.createElement(
	            VideoContainer,
	            null,
	            _react2.default.createElement(
	              Video,
	              { autoPlay: true, loop: true },
	              _react2.default.createElement('source', { src: _screenRec6.default, type: 'video/mp4' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          GridBlock,
	          { row: '39', col: '2', height: '3', width: '2', border: 'white' },
	          _react2.default.createElement(
	            BodyText,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'See days at glance.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          GridBlock,
	          { row: '37', col: '5', height: '3', width: '2', above: true },
	          _react2.default.createElement(
	            VideoContainer,
	            null,
	            _react2.default.createElement(
	              Video,
	              { autoPlay: true, loop: true },
	              _react2.default.createElement('source', { src: _screenRec2.default, type: 'video/mp4' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          GridBlock,
	          { row: '48', col: '5', height: '3', width: '2', border: 'white' },
	          _react2.default.createElement(
	            BodyText,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Improve through daily introspection.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          GridBlock,
	          { row: '46', col: '2', height: '3', width: '2', above: true },
	          _react2.default.createElement(
	            VideoContainer,
	            null,
	            _react2.default.createElement(
	              Video,
	              { autoPlay: true, loop: true },
	              _react2.default.createElement('source', { src: _screenRec4.default, type: 'video/mp4' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          GridBlock,
	          { row: '58', col: '2', height: '1', width: '2', border: 'white' },
	          _react2.default.createElement(
	            BodyText,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              'Surpass your normal.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          GridBlock,
	          { row: '58', col: '5', height: '1', width: '2', bg: 'white' },
	          _react2.default.createElement(
	            BodyText,
	            { color: green },
	            _react2.default.createElement(
	              'a',
	              null,
	              'Download Now'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return V2Page;
	}(_react2.default.Component);
	
	exports.default = V2Page;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-2a72836fdc4264e1bccb.js